export const getSettings = state => state.settings.settings

export const refreshSettings = dispatch => {
  dispatch({ type: 'SETTINGS_FETCH_REQUESTED' })
}
